// 弹窗管理器
import { ref } from 'vue'
import { getAllImagesUrl, preloadImages } from '@/utils'
import EventBus from '@/utils/bus'
class PopupManager {
    queue: { component: any; params: any }[] = []
    currentPopup = ref<{ component: any; params: any } | null>(null)
    isChecking = false
    loaded: { [key: string]: boolean } = {}
    timer = null

    addPopup(component: any, params: any = {}) {
        this.queue.push({ component, params })
    }

    // 检查系统消息是否已在队列中
    isSystemMessageInQueue(messageId: number): boolean {
        return this.queue.some((popup) => {
            // 检查是否是系统消息弹框，并且消息ID相同
            // 更安全的检查：确保参数结构正确
            const hasValidMessageParam = popup.params && popup.params.message
            return hasValidMessageParam && popup.params?.message?.id === messageId
        })
    }
    insertPopup(component: any, params: any = {}) {
        this.queue.unshift({ component, params })
    }
    clearQueue() {
        this.queue = []
        this.isChecking = false
    }
    startCheck() {
        if (this.isChecking) {
            return
        }
        this.isChecking = true
        this.checkQueue()
    }
    stopCheck() {
        this.clearQueue()
        this.closeCurrentPopup()
    }
    delayCheckQueue() {
        const handleCb = () => {
            if (this.timer) {
                this.timer && clearTimeout(this.timer)
                this.timer = null
                this.clearQueue()
                EventBus.emit('checkPoint')
            }
            document.removeEventListener('click', handleCb, true)
        }
        document.addEventListener('click', handleCb, true)
        this.timer = setTimeout(() => {
            this.timer = null
            document.removeEventListener('click', handleCb, true)
            this.checkQueue()
        }, 1000)
    }

    checkQueue(isnext = true) {
        if (this.queue.length === 0) {
            this.isChecking = false
            this.currentPopup.value = null
            EventBus.emit('checkDialogEnd')
            return
        }
        const nextPopup = this.queue.shift()
        if (nextPopup && isnext) {
            // const name = nextPopup.component.__name
            // if (this.loaded[name]) {
            this.currentPopup.value = nextPopup
            // } else {
            //     this.loadImgs(name).then(() => {
            //         this.currentPopup.value = nextPopup
            //     })
            // }
        } else {
            this.stopCheck()
            EventBus.emit('checkDialogEnd')
        }
    }

    closeCurrentPopup() {
        this.currentPopup.value = null
        this.checkQueue(false)
    }
    loadImgs(name) {
        return this.preload(name, getAllImagesUrl(name))
    }
    preload(name, imagePaths = {}) {
        return preloadImages(Object.values(imagePaths)).then(() => {
            this.loaded[name] = true
        })
    }
}

export default new PopupManager()
